import React from 'react';
import { Star, Award, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const HeroSection = () => {
  const scrollToProjects = () => {
    document.querySelector('#projects').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-black">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-transparent to-transparent"></div>
      </div>
      
      {/* Spotlight Effect */}
      <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-gradient-radial from-amber-500/30 via-amber-500/10 to-transparent rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            {/* Movie Rating Style Badge */}
            <div className="flex justify-center lg:justify-start items-center space-x-4 mb-6">
              <Badge variant="outline" className="bg-amber-500/20 text-amber-300 border-amber-500/50 px-3 py-1">
                <Star className="w-4 h-4 mr-1 fill-current" />
                COMPUTER SCIENCE STUDENT
              </Badge>
              <Badge variant="outline" className="bg-red-500/20 text-red-300 border-red-500/50 px-3 py-1">
                <Calendar className="w-4 h-4 mr-1" />
                FINAL YEAR
              </Badge>
            </div>

            {/* Main Title - Movie Poster Style */}
            <div className="mb-8">
              <p className="text-amber-400 text-lg md:text-xl font-light mb-2 tracking-widest">
                NOW STARRING
              </p>
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-4 leading-none">
                <span className="bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
                  KHALIL
                </span>
                <br />
                <span className="bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600 bg-clip-text text-transparent">
                  MOHAMMAD
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 font-light tracking-wide">
                Hi there 👋🏼
              </p>
            </div>

            {/* Movie Credits Style Description */}
            <div className="mb-8 max-w-lg mx-auto lg:mx-0">
              <p className="text-lg text-gray-400 leading-relaxed">
              Computer Science student at the University of Caen, passionate about software development and building real-world projects.
              I enjoy learning, experimenting, and continuously improving the way I code.
              </p>
            </div>

            {/* Call to Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                onClick={scrollToProjects}
                className="bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
              >
                VIEW FILMOGRAPHY
              </Button>
              {/* <Button 
                variant="outline" 
                className="border-2 border-amber-500 text-amber-400 hover:bg-amber-500 hover:text-black px-8 py-3 text-lg transition-all duration-300"
              >
                WATCH TRAILER
              </Button> */}
            </div>
          </div>

          {/* Right Content - Movie Poster Style */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              {/* Main Poster Frame */}
              <div className="relative w-80 h-96 bg-gradient-to-b from-gray-800 via-gray-900 to-black rounded-lg overflow-hidden border-4 border-amber-500/30 shadow-2xl">
                {/* Poster Background */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/70"></div>
                
                {/* Profile Image Placeholder */}
                <div className="absolute inset-6 bg-gradient-to-br from-amber-500/20 to-gray-700/30 rounded-lg flex items-center justify-center">
                  <div className="text-6xl text-amber-500/50">👨🏽‍💻</div>
                </div>

                {/* Movie Poster Text Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black via-black/80 to-transparent">
                  <div className="text-center">
                    <p className="text-amber-400 text-xs tracking-widest mb-1">STARRING</p>
                    <h3 className="text-white font-black text-xl mb-1">KHALIL MOHAMMAD</h3>
                    <p className="text-gray-400 text-xs">IN A COMPUTER SCIENCE PRODUCTION</p>
                  </div>
                </div>

                {/* Award Badges */}
                <div className="absolute top-4 right-4">
                  <Award className="w-8 h-8 text-amber-500" />
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white font-bold text-sm animate-pulse">
                NEW
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent"></div>
    </section>
  );
};

export default HeroSection;